import { invert } from 'lodash';

export const ENTITY = {
    LANDING_PAGE: 'LANDING_PAGE',
};

export const ENTITY_TO_PATH_MAP = {
    [ENTITY.LANDING_PAGE]: 'advertorial',
};

export const PATH_TO_ENTITY_MAP = invert(ENTITY_TO_PATH_MAP);
